<template>
  <div class="realtime-dynamic">
    <div class="dynamic-list">
      <div v-for="(item, index) in displayData" :key="index" class="dynamic-item">
        <span class="pulse-dot" :style="{background: getPlatformColor(item.platform)}"></span>
        <span class="dynamic-time">{{ item.time }}</span>
        <span class="dynamic-platform" :style="{color: getPlatformColor(item.platform)}">{{ item.platform }}</span>
        <span class="dynamic-sku">{{ item.sku }}</span>
        <span class="dynamic-amount">¥{{ item.amount.toLocaleString() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { realtimeData } from '../mock/data'

/* 平台颜色映射 */
var platformColorMap = {
  '淘宝/天猫': '#00D4FF',
  '京东': '#00FF88',
  '拼多多': '#FF6B35',
  '抖音': '#A855F7'
}

/* 平台列表 */
var platforms = ['淘宝/天猫', '京东', '拼多多', '抖音']

/* SKU 列表 */
var skus = [
  'iPhone 16 Pro 256G 黑色', '华为Mate70 Pro', '小米15 Ultra',
  '戴森V15吸尘器', 'SK-II神仙水230ml', 'Nike Air Max 270',
  'iPad Pro M4 11寸', '索尼WH-1000XM5', '兰蔻小黑瓶50ml',
  'MacBook Pro M4 14寸', '飞利浦电动牙刷', '雅诗兰黛眼霜15ml',
  '海尔冰箱BCD-470', '美的空调KFR-35GW', '格力空调KFR-26GW'
]

var priceMap = {
  'iPhone 16 Pro 256G 黑色': 8999, '华为Mate70 Pro': 6999, '小米15 Ultra': 5999,
  '戴森V15吸尘器': 4990, 'SK-II神仙水230ml': 1540, 'Nike Air Max 270': 899,
  'iPad Pro M4 11寸': 8999, '索尼WH-1000XM5': 2499, '兰蔻小黑瓶50ml': 980,
  'MacBook Pro M4 14寸': 14999, '飞利浦电动牙刷': 599, '雅诗兰黛眼霜15ml': 510,
  '海尔冰箱BCD-470': 4599, '美的空调KFR-35GW': 3299, '格力空调KFR-26GW': 2899
}

export default {
  name: 'RealtimeDynamic',
  data: function () {
    return {
      displayData: realtimeData.slice(0, 8),
      timer: null
    }
  },
  mounted: function () {
    var self = this
    this.timer = setInterval(function () {
      self.scrollItem()
    }, 3000)
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    /* 获取平台对应颜色 */
    getPlatformColor: function (platform) {
      return platformColorMap[platform] || '#00D4FF'
    },
    /* 滚动一条：删除最后一条，头部插入新数据 */
    scrollItem: function () {
      this.displayData.pop()
      this.displayData.unshift(this.generateRandomOrder())
    },
    /* 生成随机订单数据 */
    generateRandomOrder: function () {
      var now = new Date()
      var h = String(now.getHours()).padStart(2, '0')
      var m = String(now.getMinutes()).padStart(2, '0')
      var s = String(now.getSeconds()).padStart(2, '0')
      var sku = skus[Math.floor(Math.random() * skus.length)]
      var basePrice = priceMap[sku] || 500
      var amount = Math.round(basePrice * (0.8 + Math.random() * 0.4))
      return {
        time: h + ':' + m + ':' + s,
        platform: platforms[Math.floor(Math.random() * platforms.length)],
        sku: sku,
        amount: amount
      }
    }
  }
}
</script>

<style scoped>
.realtime-dynamic {
  width: 100%;
  min-height: 200px;
  overflow: hidden;
}
.dynamic-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.dynamic-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: rgba(0,212,255,0.04);
  border-radius: 4px;
  border-left: 2px solid rgba(0,212,255,0.2);
  font-size: 12px;
  animation: fadeIn 0.5s ease;
}
.pulse-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  animation: pulse 2s infinite;
}
.dynamic-time {
  color: #7B9CC0;
  font-family: 'DIN','Courier New',monospace;
  width: 60px;
  flex-shrink: 0;
}
.dynamic-platform {
  width: 65px;
  flex-shrink: 0;
  font-size: 11px;
}
.dynamic-sku {
  flex: 1;
  color: #E0E8F0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dynamic-amount {
  color: #00FF88;
  font-family: 'DIN','Courier New',monospace;
  flex-shrink: 0;
}
@keyframes pulse {
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.8); }
  100% { opacity: 1; transform: scale(1); }
}
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
